import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import clsx from "clsx";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import MarketplaceDialog from "./MarketplaceDialog";
import * as Actions from "./Store/Actions/MarketplaceActions";
import reducer from "./Store/Reducers/MarketplaceReducer";


const styles = theme => ({
    root: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.primary.contrastText
    },
});

class MarketplaceButton extends XAPPComponent {

    state = { open: null };

    componentDidMount() {
        this.props.getListaIntegracoes();
    }

    openDialog = (_AValue = null) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    };

    render() {
        const { xappRouteParams, integracoes = null, children, className, tipo, callback, id } = this.props;
        const form = this.state;
        const integracao = _.find(integracoes, { tipo: tipo });
        return (
            <React.Fragment>
                {!_.isNull(children) &&
                    <div id={id} className={clsx(!_.isNull(className) ? className : "w-fit", "cursor-pointer")} onClick={() => this.openDialog(integracao)}>
                        {children}
                    </div>
                }
                {!_.isNull(integracoes) &&
                    <MarketplaceDialog
                        xappRouteParams={xappRouteParams}
                        open={form.open}
                        openDialog={this.openDialog}
                        isButton={true}
                        callback={callback}
                    />
                }
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getListaIntegracoes: Actions.getListaIntegracoes,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ fuse, auth, Marketplace }) {
    return {
        integracoes: Marketplace.integracoes,
        theme: fuse.settings.mainTheme,
        user: auth.user.data,
    };
}

export default withReducer("Marketplace", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketplaceButton))));
